export default __webpack_public_path__ + "static/webRotator/svg/ff4ccf1cdddb41d2cdfda8dd6f48036d.svg";